import type { AdImageEngineOverride } from "./aspectRatios";

export const ADS_EXPRESS_IMAGE_ENGINE_SELECTOR_FLAG = "ads_express_image_engine_selector";
export type AdsExpressImageEngineChoice = AdImageEngineOverride | "gpt-image-2.5";

export const ADS_EXPRESS_IMAGE_ENGINE_CHOICES: readonly AdsExpressImageEngineChoice[] = [
  "gpt-image-2",
  "flux-2-pro",
  "gpt-image-2.5",
];

export function isAdsExpressImageEngineChoice(value: unknown): value is AdsExpressImageEngineChoice {
  return typeof value === "string" && (ADS_EXPRESS_IMAGE_ENGINE_CHOICES as readonly string[]).includes(value);
}

/** Both sources are immutable run snapshots. An explicit user choice wins
 * over automatic identity routing and the 9:16 admin override. Without
 * a user choice, identity and admin routing stay unchanged. */
export function resolveAdsExpressRenderEngine(args: {
  adminEngine?: AdImageEngineOverride | null;
  userEngine?: AdsExpressImageEngineChoice | null;
  ratio: string;
  isMeme: boolean;
  personIdentityActive?: boolean;
}): AdsExpressImageEngineChoice | null {
  if (args.isMeme) return null;
  if (args.userEngine) return args.userEngine;
  if (args.personIdentityActive) return "gpt-image-2";
  if (args.ratio === "9:16" && args.adminEngine) return args.adminEngine;
  return null;
}